module.exports = __webpack_public_path__ + "img/sms-panel-bg.fd8aece9.png";